import React from "react";
import GenImg from "./GenImg";
import GenPortraits from "./GenPortraits";

class Enhance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    };
    document.cookie = "cartCounter=25;";
  }

  componentDidMount() {}

  Fnavbar = () => {
    // let Usernavbar = GenImg(this.props.apikey);
    let Usernavbar = GenPortraits(false, 0);
    return Usernavbar;
  };

  render() {
    return (
      <React.Fragment>
        <this.Fnavbar />
      </React.Fragment>

      //   <div style={{ paddingLeft: 200 }}>
      //     <h3>Welcome to Enhance Images!</h3>
      //   </div>
    );
  }
}
export default Enhance;
